<script type="text/javascript">
	import { onMount } from "svelte";
	import AuthStore from "../../Auth/Store";
	import MapControlType from "../../Map/Enums/MapControlType";
	import MapLayerManager from "../../Map/MapLayerManager";
	import MapStore from "../../Map/Store";
	import ModalWindow from "../ModalWindow.svelte";
	import AnnotationsStore from "./Store";
		  
	let visible = AnnotationsStore.meta.visible;
	let control = MapStore.control;
	$: {
		if (!$visible) {
			$control = MapControlType.PAN;
		}
		MapLayerManager.updateVisibleLayers();
		MapLayerManager.updateCustomMarkers();
	}
	let dummyButton = AnnotationsStore.data.dummyButton;
	let blobFilename = AnnotationsStore.data.blobFilename;

	onMount(()=>{
		AuthStore.events.onStartLogout.addOnce(()=>{
			AnnotationsStore.actions.clearAll();
		});
	});

</script>

<style type="text/scss">
	#annotations-content {
		p, p b, p i {
			line-height: 1.6em;
			font-size: 14px;
		}
	}
</style>

<ModalWindow
	title={`Annotations`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible}
	>
	<div id='annotations-content'>
		<p><b>Usage:</b><br/> Please see the extra toolbar buttons at the top-left of the Map view.</p>
		<p><i><b>Note:</b><br/> Annotations are saved in your login session and are deleted when logging out.</i></p>

		<button class='btn btn-sm btn-sml bg-secondary' style={"cursor:pointer;"} on:click={AnnotationsStore.actions.exportGeojson}>Export GeoJson</button>
		<button class='btn btn-sm btn-sml bg-secondary' style={"cursor:pointer;"} on:click={AnnotationsStore.actions.exportCsv}>Export CSV</button>
		<button class='btn btn-sm btn-sml bg-error' style={"cursor:pointer;"} on:click={AnnotationsStore.actions.clearAll}>Delete All Annotations</button>

		<a bind:this={$dummyButton} id="export_data_button" href="javascript:;" download={$blobFilename} style="display:none;">&nbsp;</a>
	</div>


</ModalWindow>
